import React, { useCallback, useState } from 'react';
import { Box, InputBase, makeStyles } from '@material-ui/core';
import DiaLog from '../../../../../components/Dialog';
import { i18n } from '../../../../../language';
import { systemAPI } from '../../../../../apis';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    color: '#7d86a9',
    fontSize: '0.875rem',
  },
  input: {
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
    fontSize: '1.125rem',
    border: 'solid 1px #e4e7eb',
    height: '3.5rem',
    borderRadius: '10px',
    paddingLeft: '1rem',
  },
}));

const EditHospital = ({ handleClose, handleRefresh, data }) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    hospitalName: data.hospitalName ?? '',
    hospitalCode: data.hospitalCode ?? '',
  });

  const formHandler = useCallback(
    (type) => (event) => {
      setFormData((oldData) => ({
        ...oldData,
        [type]: event.target.value,
      }));
    },
    []
  );

  const submitHandler = useCallback(async () => {
    try {
      await systemAPI.updateHospital({ ...formData, hospitalId: data.hospitalId });
      handleRefresh();
    } catch (error) {
      console.log(error);
    }
  }, [formData, handleRefresh, data]);

  return (
    <DiaLog
      open={true}
      title={i18n.t('SETTING_EDIT_HOSPITAL')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_UPDATE')}
      handleConfirm={submitHandler}
      handleClose={handleClose}
      handleCancel={handleClose}
      cancelStyle={{ border: 'unset', backgroundColor: '#ff655c', color: '#fff' }}
      confirmStyle={{ border: 'unset', backgroundColor: '#28d2ab', color: '#fff' }}
    >
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem">
        <div className={classes.title}>{i18n.t('SETTING_HOSPITAL_POPUP_NAME')}*</div>
        <InputBase
          className={classes.input}
          value={formData.hospitalName}
          onChange={formHandler('hospitalName')}
          inputProps={{ maxLength: 60 }}
        />
      </Box>
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem" mt="2rem">
        <div className={classes.title}>{i18n.t('SETTING_HOSPITAL_CODE')}*</div>
        <InputBase
          className={classes.input}
          value={formData.hospitalCode}
          onChange={formHandler('hospitalCode')}
          inputProps={{ maxLength: 60 }}
        />
      </Box>
    </DiaLog>
  );
};

export default EditHospital;
